export enum ROUTES_MAIN {
  AUTH = 'auth',
  DASHBOARD = 'dashboard'
}
